import { Vue, Options } from 'vue-class-component';
import Menu from 'primevue/menu';
import MegaMenu from 'primevue/megamenu';
import { mapState } from 'vuex';
import { SET_SIDEBAR_EXPANDED } from '@/core/store/action-types';
import MegaMenuItem from '@/core/models/menu-items';
import { EntrancePlantDetailDTO } from 'client-generator/generated-clients/plants';

@Options({
  name: 'TheSidebar',
  components: {
    Menu,
    MegaMenu,
  },
  computed: {
    ...mapState([
      'menuItemsContextual',
      'isSidebarExpanded',
      'currentEntrancePlant',
    ]),
  },
})
export default class TheSidebar extends Vue {
  isSidebarExpanded!: boolean;
  menuItemsContextual!: MegaMenuItem[];
  currentEntrancePlant!: EntrancePlantDetailDTO;
  toggleSidebarExpand(doShow: boolean) {
    this.$store.dispatch(SET_SIDEBAR_EXPANDED, doShow);
  }
}
